export var OutputType;
(function (OutputType) {
    OutputType[OutputType["SVG"] = 0] = "SVG";
    OutputType[OutputType["CANVAS"] = 1] = "CANVAS";
})(OutputType || (OutputType = {}));
